import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Contrast } from "../../../types/general.types";
import { LabelSizes, LabelVariants, LabelWeights, } from "../../../Atoms/Text/Label/constants";
import { Label } from "../../../Atoms";
import { Icon } from "../..";
import { IconSizes, IconVariants, } from "../../Images/Icon/constants";
import StyledButton from "./Action.style";
import { ActionVariants, ActionWeights, } from "./constants";
const Action = ({ onClick = () => { }, onMouseOver = () => { }, onMouseLeave = () => { }, isDisabled = false, variant = ActionVariants.primary, contrast = Contrast.default, weight = ActionWeights.medium, text = "", iconName = "", iconPosition = "end", }) => {
    const [onHover, setOnHover] = useState(false);
    const internalOnMouseLeave = () => {
        setOnHover(false);
        onMouseLeave;
    };
    const getLabelProps = (variant, isDisabled, weight, contrast) => {
        const labelProps = {
            weight: LabelWeights.bold,
            size: weight === ActionWeights.medium ? LabelSizes.medium : LabelSizes.small,
            isVariant: onHover,
            contrast: contrast,
        };
        if (isDisabled)
            return { labelProps, isDisabled: true, kind: LabelVariants.neutral };
        switch (variant) {
            case ActionVariants.neutral: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    isDisabled: isDisabled,
                };
            }
            case ActionVariants.primary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.primary,
                    isDisabled: isDisabled,
                };
            }
            case ActionVariants.secondary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.secondary,
                    isDisabled: isDisabled,
                };
            }
        }
    };
    const getIconProps = (variant, isDisabled, weight, contrast) => {
        const iconProps = {
            size: weight === ActionWeights.medium ? IconSizes.medium : IconSizes.small,
            isColorVariant: onHover,
            contrast: contrast,
        };
        switch (variant) {
            case ActionVariants.neutral: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    isDisabled: isDisabled,
                };
            }
            case ActionVariants.primary: {
                return {
                    ...iconProps,
                    variant: IconVariants.primary,
                    isDisabled: isDisabled,
                };
            }
            case ActionVariants.secondary: {
                return {
                    ...iconProps,
                    variant: IconVariants.secondary,
                    isDisabled: isDisabled,
                };
            }
        }
    };
    return (_jsxs(StyledButton, { onClick: onClick, onMouseOver: onMouseOver, onMouseEnter: () => setOnHover(true), onMouseLeave: internalOnMouseLeave, isDisabled: isDisabled, variant: variant, contrast: contrast, children: [iconName && iconPosition === "start" && (_jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, weight, contrast) })), text && (_jsx(Label, { ...getLabelProps(variant, isDisabled, weight, contrast), children: text })), iconName && iconPosition === "end" && (_jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, weight, contrast) }))] }));
};
export default Action;
//# sourceMappingURL=Action.js.map